// * MUI
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

// * Icons
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';

// * Queries
import { useDeleteEnergyInitiativeMutation } from '@/api/recalcV2/endpoints/energyInitiativesApiSlice';

// * Redux
import { useDispatch } from 'react-redux';
import { showSnackbar } from '@/redux/snackbarSlice';

const DeleteInitiativeDialog = ({ open, onClose, energyGroup, initiative }) => {
  const dispatch = useDispatch();
  const [deleteEnergyInitiative] = useDeleteEnergyInitiativeMutation();

  const handleDeleteInitiative = async () => {
    if (!energyGroup || !initiative) return;
    try {
      await deleteEnergyInitiative({
        accountId: energyGroup.accountId,
        energyInitiativeId: initiative.id,
      }).unwrap();
      dispatch(
        showSnackbar({ message: 'Initiativ fjernet', severity: 'success' }),
      );
      onClose();
    } catch (error) {
      dispatch(
        showSnackbar({
          message: 'Der opstod en fejl under fjernelse af initiativ',
          severity: 'error',
        }),
      );
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirm</DialogTitle>
      <DialogContent dividers>
        <Typography>
          Are you sure you want to delete this initiative? You will no longer be
          able to view or manage it.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="text">
          Cancel
        </Button>
        <Button
          onClick={handleDeleteInitiative}
          startIcon={<DeleteRoundedIcon />}
          variant="contained"
          color="error"
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteInitiativeDialog;
